export const isPixBilling = (preview) => preview?.billing_type === "Pix"

export const needsCreditCardForPlanChange = (preview, currentBillingInterval, targetBillingInterval, targetIsPaid = true) => (
  preview?.billing_type === "CreditCard" && (
    (preview?.direction === "Upgrade" && Number(preview?.charge_today) > 0) ||
    (
      preview?.direction === "Downgrade" &&
      targetIsPaid &&
      currentBillingInterval === "Yearly" &&
      targetBillingInterval === "Monthly"
    )
  )
)

export const willCreatePixInvoice = (preview) => (
  isPixBilling(preview) &&
  preview?.direction !== "Downgrade" &&
  !preview?.charge_waived &&
  Number(preview?.charge_today) > 0
)

export const needsBillingProfileBeforePixPurchase = (preview, pendingActions = []) => (
  willCreatePixInvoice(preview) &&
  pendingActions.some((action) => action?.type === "missing_billing_profile")
)

export const shouldRedirectToBillingProfile = (billingProfileStatus) => (
  billingProfileStatus === "missing"
)

export const buildPixPurchaseResumeState = (checkoutState) => ({
  ...(checkoutState || {}),
  resumePixPurchase: true,
})

export const didPendingPlanActivate = (pendingPlanId, subscription) => (
  Boolean(pendingPlanId) &&
  !subscription?.pending_payment &&
  subscription?.plan?.id === pendingPlanId
)
